import { Link } from "react-router-dom";

function ProjectInExplore({ content, handleLodingNewproject }) {
  return (
    <div className="mt-0 px-3 mt-4">
      <Link to={`/project/${content.route}`} onClick={handleLodingNewproject}>
        <img
          loading="lazy"
          src={`/${content.img}`}
          className="live-demo img-fluid  rounded-start rounded-3 border border-1"
          alt="..."
          databstoggle="tooltip"
          databsplacement="bottom"
          databstitle="It may takes a few seconds to display due to server issues."
          databscustomclassname="custom-tooltip"
        />
      </Link>
      <h6 className="text-capitalize mt-3">
        <Link
          to={content.linkDemo}
          target="_blank"
          className="text-decoration-none "
        >
          {content.title}
        </Link>
      </h6>
      <div className="d-flex justify-content-start gap-2 flex-wrap py-3 pb-0 ">
        {content.skills.map((skill, index) => (
          <small
            className="p-2 py-1 rounded-2 fw-normal  border border-1 d-block "
            style={{ fontSize: ".8rem" }}
            key={index}
          >
            {skill}
          </small>
        ))}
      </div>
    </div>
  );
}

export default ProjectInExplore;
